import { callGet, callPost, callPut, laravelApiV3, laravelApiV3Advisor } from "./index";
import { User } from "models/User";

export class UserAPI {
  static async updatePhone(userId:number, phone: string | null): Promise<boolean> {
    try {
      callPost(`users/${userId}/phone`, { phone })
      return true
    } catch (e) {
      console.error((e as any)?.message)
    }

    return false
  }

  static async getUserByEmail(email: string, authToken: string): Promise<User | undefined> {
    try {
      const response = await callGet(`user-with-email/${encodeURIComponent(email)}`, true, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      return User.fromJSON(response?.data)
    } catch (e) {
      console.error((e as any)?.message)
    }
  }

  static async getAdvisorByEmail(email: string, authToken: string): Promise<User | undefined> {
    try {
      const response = await callGet(`advisor-with-email/${encodeURIComponent(email)}`, true, {
        baseURL: laravelApiV3Advisor,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      return User.fromJSON(response?.data)
    } catch (e) {
      console.error((e as any)?.message)
    }
  }
  
  static async completeOnboarding(userId:number, skipEvent = false): Promise<void> {
    try {
      let body: any = undefined
      if (skipEvent) {
        body = {
          skip_event: true,
        }
      }
      await callPut(`users/${userId}/complete-on-boarding`, body);
    } catch (e) {
      console.error("failed to complete onboarding, " + (e as any)?.message)
    }
  }

  static async completeProbateQuiz(userId:number, redirectTo: string, jurisdiction: string, packetName: string, numForms: number,): Promise<void> {
    try {
      await callPut(`users/${userId}/complete-probate-quiz`, {
        login_link: redirectTo,
        jurisdiction,
        packet_name: packetName,
        num_forms: numForms,
      });
    } catch (e) {
      console.error("failed to complete probate quiz, " + (e as any)?.message)
    }
  }

  static async createOtherUser(estateId:number, user: User): Promise<User | undefined> {
    try {
      const response = await callPost(`estates/${estateId}/users`, user.toJson());
      return User.fromJSON(response?.data)
    } catch (e) {
      console.error((e as any)?.message)
    }
  }

  static async handleAutoSignup(email: string, additionalSignupFields: any): Promise<User | undefined> {
    try {
      const response = await callPost(`users/signup/${encodeURIComponent(email)}`, additionalSignupFields);
      if(response?.status === 429) {
        throw new Error("User already exists")
      }
      return User.fromJSON(response?.data)
    } catch (e) {
      console.error((e as any)?.message)
    }
  }
}
